import { FloatButton } from "antd";
import { useCallback, useRef } from "react";
import styles from "./ChatButton.module.less";
import { useChatContext } from "../../contexts/ChatContext";
import ChatWindow from "./components/ChatWindow";

const ChatButton = () => {
  const { isChatVisible, toggleChat } = useChatContext();
  const chatContainerRef = useRef<HTMLDivElement>(null);

  const handleClick = useCallback(() => {
    toggleChat();
  }, [toggleChat]);

  return (
    <>
      <FloatButton
        icon={
          <div className={styles.mikeIcon}>
            <img
              src="/images/mike.opac.png"
              alt="Chat"
              width="42"
              height="42"
            />
          </div>
        }
        onClick={handleClick}
        tooltip="Chat"
        className={styles.chatButton}
        type="primary"
        aria-label="Chat"
      />

      {isChatVisible && (
        <div ref={chatContainerRef} className={styles.chatContainer}>
          <ChatWindow />
        </div>
      )}
    </>
  );
};

export default ChatButton;
